import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import autoBind from 'auto-bind';
import { setReturnShipmentTrackingNumber, setReturnShipmentCarrier } from 'actions/tools/OrdersSearchActions';
import { loadInfoForItemPriceMatch } from 'actions/tools/DecisionTree/DiscountActions';
import { loadShippingInformationForReturns } from 'actions/tools/DecisionTree/ReturnActions';
import { setItemAndDiscountPeriodMatches } from 'actions/searchActions';
import {
  getCurrentDecisionNodeContent,
  getDecisionNodeAtPath,
  getSimplrAccountIdOfSelectedTicket,
  getDiscountPeriods,
  getItemAndDiscountPeriodMatches,
} from 'extractFromState';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SearchDropDown from 'components/DropDown/SearchDropDown/SearchDropDown';
import { returnToPreviousMacroWizardPath, setDiscountPeriods } from 'actions/searchActions';
import { getSelectedLineItems, getOrderingSystem } from 'selectors/tools';
import { getDiscountPeriodsForAccount } from 'api/partner';
import { getDiscountPeriodFields } from 'util/formatUtil';
import { getItemId } from 'util/decisionTreeUtil';
import { NextButton, BackButton } from 'components/common/buttonsComponents';
import {
  Container,
  InnerContainer,
  Title,
  Label,
  SubTitle,
  SubText,
  Section,
  InstructionsSection,
  Instructions,
} from './DTSelectDiscountPeriodForItemsNode.styles';
import { ActionsButtonsWrapper } from '../../DecisionTree.styles';

export class DTSelectDiscountPeriodForItemsNode extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      loading: false,
    };
  }

  async UNSAFE_componentWillMount() {
    // clears matches on each pass
    this.props.setItemAndDiscountPeriodMatches({});
    const discountPeriodsParseObjects = await getDiscountPeriodsForAccount(this.props.selectedSimplrAccountId);
    const discountPeriods = getDiscountPeriodFields(discountPeriodsParseObjects);
    this.props.setDiscountPeriods(discountPeriods);
  }

  async nextButtonAction() {
    this.setState({ loading: true });
    await this.props.loadInfoForItemPriceMatch();
    this.setState({ loading: false });
  }

  backButtonAction() {
    this.props.returnToPreviousMacroWizardPath();
  }

  getItemNameAndQuantity(item) {
    const { orderingSystem } = this.props;
    // TODO: Add default case
    // eslint-disable-next-line default-case
    switch (orderingSystem) {
      case 'shopify':
        return (
          <b>
            {parseInt(item.quantity)}x {item.name}
          </b>
        );
    }
  }

  handleSelectDiscountPeriod(discObj, item) {
    const itemAndDiscountPeriodMatches = cloneDeep(this.props.itemAndDiscountPeriodMatches);
    const itemId = getItemId(item, this.props.orderingSystem);
    if (discObj) {
      // set the item id to the discount record - in none found, set to false
      itemAndDiscountPeriodMatches[itemId] =
        discObj.value === 'none'
          ? { title: 'none' }
          : this.props.discountPeriods.find((period) => discObj.value === period.objectId) || false;
    } else {
      delete itemAndDiscountPeriodMatches[itemId];
    }
    this.props.setItemAndDiscountPeriodMatches(itemAndDiscountPeriodMatches);
  }

  getCurrentDiscountPeriodOptions() {
    const out = this.props.discountPeriods.map((period) => ({
      value: period.objectId,
      label: period.title,
    }));

    return [...out, { value: 'none', label: 'No discount is applicable' }];
  }

  getSelectedDiscount(item) {
    // id of the selected customer item
    const itemId = getItemId(item, this.props.orderingSystem);

    return this.props.itemAndDiscountPeriodMatches[itemId];
  }

  getSelectedDiscountDropdownOption(item) {
    const selectedDiscountPeriod = this.getSelectedDiscount(item);
    // get the data for the dropdown
    if (selectedDiscountPeriod) {
      if (selectedDiscountPeriod.title !== 'none') {
        return this.getCurrentDiscountPeriodOptions().find(
          (option) => option.value === selectedDiscountPeriod.objectId
        );
      }

      return 'none';
    }

    return false;
  }

  noDiscountApplicableSelected(item) {
    const selectedDiscount = this.getSelectedDiscount(item);

    return selectedDiscount && selectedDiscount.title === 'none';
  }

  displayInstructions(item) {
    const selectedDiscount = this.getSelectedDiscount(item);

    return (
      this.getSelectedDiscountDropdownOption(item) &&
      !this.noDiscountApplicableSelected(item) &&
      selectedDiscount.discountQualificationInstructions
    );
  }

  generateLineItemSections() {
    return this.props.selectedLineItems.map((item, idx) => {
      const selectedDiscountPeriod = this.getSelectedDiscount(item);

      return (
        <Section key={JSON.stringify(item)}>
          <Label>{this.getItemNameAndQuantity(item)}</Label>
          <SearchDropDown
            selectedId={this.getSelectedDiscountDropdownOption(item)}
            options={this.getCurrentDiscountPeriodOptions()}
            placeholder={'Select a discount period'}
            onChange={(obj) => this.handleSelectDiscountPeriod(obj, item)}
            zIndexOff={true}
          />
          {this.displayInstructions(item) && (
            <InstructionsSection>
              <SubText>
                Here is a description of the discount you selected. Please make sure the item the customer is inquiring
                about qualifies for this discount according to the description below. If you think the item does not
                qualify, please instead select 'No discount is applicable' from the dropdown menu.
              </SubText>
              <Instructions>{selectedDiscountPeriod.discountQualificationInstructions}</Instructions>
            </InstructionsSection>
          )}
        </Section>
      );
    });
  }

  render() {
    const { content, selectedLineItems, itemAndDiscountPeriodMatches } = this.props;

    // only enable buttons if line items are selected and loading is false
    const enableNextButton =
      Object.keys(itemAndDiscountPeriodMatches).length === selectedLineItems.length && !this.state.loading;

    return (
      <Container>
        <InnerContainer>
          <Title>{content.title}</Title>
          <SubTitle>{content.subText}</SubTitle>
          {this.generateLineItemSections()}
        </InnerContainer>
        <ActionsButtonsWrapper>
          <NextButton
            active={enableNextButton}
            disabled={!enableNextButton}
            type="submit"
            onClick={() => this.nextButtonAction()}
          >
            NEXT
          </NextButton>
          <BackButton onClick={() => this.backButtonAction()}>BACK</BackButton>
        </ActionsButtonsWrapper>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    content: getCurrentDecisionNodeContent(state),
    decisionNode: getDecisionNodeAtPath(state),
    selectedLineItems: getSelectedLineItems(state),
    orderingSystem: getOrderingSystem(state),
    selectedSimplrAccountId: getSimplrAccountIdOfSelectedTicket(state),
    discountPeriods: getDiscountPeriods(state),
    itemAndDiscountPeriodMatches: getItemAndDiscountPeriodMatches(state),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(
      {
        setDiscountPeriods,
        loadShippingInformationForReturns,
        setReturnShipmentTrackingNumber,
        setReturnShipmentCarrier,
        returnToPreviousMacroWizardPath,
        setItemAndDiscountPeriodMatches,
        loadInfoForItemPriceMatch,
      },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DTSelectDiscountPeriodForItemsNode);
